/* <soh-mega-menu>: each [data-mega-trigger] controls the panel with id = aria-controls.
   Desktop hover (with intent delay) + click/tap toggle, Esc closes, arrow keys move between top-level items. */
class SohMegaMenu extends HTMLElement {
  connectedCallback() {
    this.triggers = [...this.querySelectorAll('[data-mega-trigger]')];
    const hover = matchMedia('(hover: hover) and (min-width: 990px)');
    this.triggers.forEach((t, i) => {
      const item = t.closest('[data-mega-item]');
      t.addEventListener('click', (e) => { e.preventDefault(); this.toggle(t, t.getAttribute('aria-expanded') !== 'true'); });
      item.addEventListener('mouseenter', () => { if (hover.matches) { clearTimeout(this.timer); this.timer = setTimeout(() => this.toggle(t, true), 80); } });
      item.addEventListener('mouseleave', () => { if (hover.matches) { clearTimeout(this.timer); this.timer = setTimeout(() => this.toggle(t, false), 160); } });
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); const n = this.triggers[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.triggers.length) % this.triggers.length]; n.focus(); }
        if (e.key === 'ArrowDown') { e.preventDefault(); this.toggle(t, true); const f = document.getElementById(t.getAttribute('aria-controls')).querySelector('a'); f && f.focus(); }
      });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { const open = this.triggers.find(t => t.getAttribute('aria-expanded') === 'true'); if (open) { this.toggle(open, false); open.focus(); } } });
    document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.closeAll(); });
  }
  closeAll() { this.triggers.forEach(t => this.toggle(t, false)); }
  toggle(t, open) {
    if (open) this.triggers.forEach(o => o !== t && this.toggle(o, false));
    t.setAttribute('aria-expanded', String(open));
    const p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !open;
  }
}
customElements.define('soh-mega-menu', SohMegaMenu);
